window.c24LpFrameJsReady.then(function() {
    window.Check24 = window.Check24 || {};
    window.Check24.birthday = {
        init: function() {
            window.Check24.birthday.birthdayBox = document.querySelectorAll('.c24-birthday-box');
            window.Check24.birthday.inputElement = document.querySelectorAll('.c24-yellow-box .c24-yellow-box-birthday-input');
            window.Check24.birthday.errorTextElement = document.querySelectorAll('.c24-yellow-box .c24-birthdate-form-error');
            window.Check24.birthday.formElement = document.querySelectorAll('.c24-yellow-box .c24-form-evo');
            window.Check24.birthday.submitInput = document.querySelectorAll('.c24-yellow-box .c24-yellow-box-submit-input');
            window.Check24.birthday.planeInput = false;
            window.Check24.birthday.newYearFormat = false;
            window.Check24.birthday.bpmBirthdayKey = 'person_birthday';
            window.Check24.birthday.errorTextEmpty = 'Bitte geben Sie ein gültiges Datum an.';

            window.Check24.birthday.submit();
            window.Check24.birthday.handleClick();
            window.Check24.birthday.handleKeyUp();
            window.Check24.birthday.handleBlur();
            window.Check24.birthday.handleKeyPress();
            window.Check24.birthday.prefillInput();
        },
        handleClick: function() {
            window.Check24.birthday.inputElement.forEach(function (element) {
                element.addEventListener('click', function () {
                    element.closest('.c24-yellow-box-input-wrapper').classList.remove('c24-error');
                });
            });
        },
        handleKeyUp: function() {
            window.Check24.birthday.inputElement.forEach(function (element) {
                element.addEventListener('keyup', function (e) {
                    window.Check24.birthday.formatValue('keyup', e, element.value);
                });
            });
        },
        handleBlur: function() {
            window.Check24.birthday.inputElement.forEach(function (element) {
                element.addEventListener('blur', function (e) {
                    window.Check24.birthday.formatValue('blur', e, element.value);
                });
            });
        },
        handleKeyPress: function() {
            window.Check24.birthday.inputElement.forEach(function (element, event) {
                element.addEventListener('keypress', function () {
                    return (event.keyCode >= 48 && event.keyCode <= 57) || event.keyCode == 13;
                });
            });
        },
        getMinAge: function(element) {
            const minAge = element.dataset?.minage;

            if (!element || typeof minAge !== 'string' || minAge === '') {
                return null;
            }
            return minAge;
        },
        getMaxAge: function(element) {
            const maxAge = element.dataset?.maxage;

            if (!element || typeof maxAge !== 'string' || maxAge === '') {
                return null;
            }
            return maxAge;
        },
        getErrorTextMinAge: function(element) {
            if (!element || window.Check24.birthday.getMinAge(element) === null) {
                return null;
            }
            if (window.Check24.birthday.getCustomMinAgeMessage(element)) {
                return window.Check24.birthday.getCustomMinAgeMessage(element);
            }
            return 'Mindestalter' + ' ' + `${window.Check24.birthday.getMinAge(element).toString()}` + ' ' + 'Jahre';
        },
        getErrorTextMaxAge: function(element) {
            if (!element || window.Check24.birthday.getMaxAge(element) === null) {
                return null;
            }
            if (window.Check24.birthday.getCustomMaxAgeMessage(element)) {
                return window.Check24.birthday.getCustomMaxAgeMessage(element);
            }
            return 'Höchstalter' + ' ' + `${window.Check24.birthday.getMaxAge(element).toString()}` + ' ' + 'Jahre';
        },
        getCustomMinAgeMessage: function(element) {
            const minAgeMessage = element.dataset?.minagemessage;

            if (!element || typeof minAgeMessage !== 'string' || minAgeMessage === '') {
                return null;
            }
            return minAgeMessage;
        },
        getCustomMaxAgeMessage: function(element) {
            const maxAgeMessage = element.dataset?.maxagemessage;

            if (!element || typeof maxAgeMessage !== 'string' || maxAgeMessage === '') {
                return null;
            }
            return maxAgeMessage;
        },
        getIsRequired: function(element) {
            if (!element || element?.dataset?.required === null || element?.dataset?.required === 'false') {
                return false;
            }
            return true;
        },
        getIsDefaultErrorText: function(element) {
            if (!element || element?.dataset?.defaulterror === null || element?.dataset?.defaulterror === 'false') {
                return false;
            }
            return true;
        },
        getIsPlaneInput: function(element) {
            if (!element) {
                return false;
            }
            return element?.dataset?.plane === 'true';
        },
        getLoggedInUserBirthday: function(element) {
            if (!element) {
                return null;
            }
            return element.dataset?.userbirthday;
        },
        prefillInput: function() {
            if (!window.Check24.birthday.bpmBirthdayKey) {
                return;
            }

            window.Check24.BPM.get(window.Check24.birthday.bpmBirthdayKey, function(data) {
                window.Check24.birthday.inputElement.forEach((element) => {
                    if (!element) {
                        return;
                    }

                    if (typeof data !== 'undefined' && data !== '') {
                        let date = new Date(data);
                        let day = date.getDate();
                        let month = date.getMonth() + 1;

                        if (day < 10) {
                            day = '0' + day;
                        }
                        if (month < 10) {
                            month = '0' + month;
                        }

                        let formattedDate = day + '.' + month + '.' + date.getFullYear();
                        element.value = formattedDate;
                    } else {
                        let accountDate = window.Check24.birthday.getLoggedInUserBirthday(element);
                        element.value = accountDate;
                    }
                });
            });
        },
        formatValue: function(type, e, bdValue) {
            if (type === 'keyup') {
            // Skip editing through backspace, delete, Ctrl+X and Ctrl+V
                if (e.keyCode === 8 || e.keyCode === 46 || (e.keyCode === 88 && e.ctrlKey) || (e.keyCode === 86 && e.ctrlKey)) {
                    return false;
                }
                // Initialize values
                let day = null;
                let month = null;
                let year = null;

                // No action on empty value
                if (bdValue === '') {
                    return '';
                }

                if (e.key !== '.') {
                    bdValue = bdValue.replace(/\.$/, '');
                }
                // Split date into parts and correct month and day
                let parts = bdValue.split(/\./, 3);
                // Parse day
                day = parseInt(parts[0]);
                if (parts.length === 1 && parts[0].length === 1 && day > 3) {
                    day = '0' + day;
                } else if ((parts[0].length > 1 && day < 10) || (parts.length > 1 && day > 0 && day < 10)) {
                    if (day !== 0) {
                        day = '0' + day;
                    }
                } else if (parts.length === 1 && parts[0].length === 2 && day > 31) {
                    const output = [];
                    const sNumber = day.toString();
                    for (let i = 0, len = sNumber.length; i < len; i += 1) {
                        output.push(+sNumber.charAt(i));
                    }
                    day = '0' + output[0];
                    month = '0' + output[1];
                }
                day = '' + day;
                // Parse month
                if (parts.length > 1) {
                    month = '';
                    if (parts[1] !== '') {
                        month = parseInt(parts[1]);
                        if (parts.length === 2 && ((parts[1].length === 1 && month > 1) || (parts[1].length > 1 && month < 10))) {
                            if (month !== 0) {
                                month = '0' + month;
                            }
                        } else if (parts.length === 2 && parts[1].length === 2 && month > 12) {
                            const output = [];
                            const sNumber = month.toString();
                            for (let i = 0, len = sNumber.length; i < len; i += 1) {
                                output.push(+sNumber.charAt(i));
                            }
                            month = '0' + output[0];
                            year = output[1];
                        }
                        if (parts.length > 2) {
                            if (month > 0 && month < 10) {
                                month = '0' + month;
                            }
                        }
                        month = '' + month;
                    }
                }
                // Parse year
                if (parts.length == 3) {
                    year = parts[2];
                    const currentMonth = new Date().getMonth() + 1;
                    const currentDay = new Date().getDate();
                    const currentYear = new Date().getFullYear().toString().substr(-2);
                    const isDateInFuture = currentMonth < month || currentDay < day;
                    const isYearInFuture = parseInt(year) > currentYear;

                    if (parts[2].length == 2) {
                        if (this.newYearFormat === true ?
                            ((parseInt(year) === 23 && isDateInFuture) || isYearInFuture)
                            : (parseInt(year) > 20)) {
                            year = '19' + year;
                        } else if (this.newYearFormat === true ?
                            (!isYearInFuture && (parseInt(year) !== 20 && parseInt(year) !== 19))
                            : (parseInt(year) < 19)) {
                            year = '20' + year;
                        }
                    } else if (parts[2].length > 4) {
                        year = year.substring(0, 4);
                    }
                }
                // Compose value
                bdValue = day;
                if (month != null || day.length == 2) {
                    bdValue += '.';
                }
                if (month != null && month != '') {
                    bdValue += month;
                    if (year != null || month.length == 2) {
                        bdValue += '.';
                    }
                    if (year != null && year != '') {
                        bdValue += year;
                    }
                }
                // Return formatted date
                const date = e.target.closest('.c24-yellow-box-birthday-input').value;
                if (date !== '') {
                    e.target.closest('.c24-yellow-box-birthday-input').value = bdValue;
                }
            } else if (type === 'blur') {
            // Let empty values
                if (bdValue === undefined) {
                    return false;
                }
                // Apply regex (allows 1 digit day, 1 digit month and 2 digit year)
                let matches = bdValue.match(/^((0?[1-9]|[12]\d|3[01])\.(0?[1-9]|1[0-2])\.((19|20)?\d{1,2}))$/);
                if (matches == null) {
                // Wrong date format, do not edit value
                    return false;
                }
                // Initialize date parts
                let day = ('' + parseInt(matches[2])).padStart(2, '0');
                let month = ('' + parseInt(matches[3])).padStart(2, '0');
                let year = parseInt(matches[4]);
                // Prepend century if we have a 2-digit year
                if (year < 100) {
                    year += 1900;
                    if (new Date().getFullYear() - year > 100) {
                        year += 100;
                    }
                }
                // Return formatted string
                bdValue = day + '.' + month + '.' + year;
                // Return formatted date
                e.target.closest('.c24-yellow-box-birthday-input').value = bdValue;
            }
        },
        submit: function() {
            window.Check24.birthday.formElement.forEach((formEle) => {
                formEle.addEventListener('submit', function(event) {
                    const element = formEle.querySelector('.c24-yellow-box-birthday-input');
                    const errorElement = formEle.querySelector('.c24-birthdate-form-error');
                    const isEmpty = element.value.length === 0;
                    const isRequired = window.Check24.birthday.getIsRequired(element);
                    const isValidDate = window.Check24.birthday.isValidDate(element, element.value);
                    const isPlaneInput = window.Check24.birthday.getIsPlaneInput(element);

                    if ((isRequired && isEmpty) || (!isValidDate && !isEmpty && !isPlaneInput) || element.value === '0') {
                        window.Check24.birthday.error(window.Check24.birthday.errorTextEmpty, element);
                        event.preventDefault();

                        return false;
                    }

                    let today = new Date();
                    let dbDate = new Date(window.Check24.birthday.getDate(false, element.value));
                    let difference = today.getTime() - dbDate.getTime();
                    let yearsDifference = difference / 1000 / 60 / 60 / 24 / 365.25;
                    let minAge = window.Check24.birthday.getMinAge(element);
                    let maxAge = window.Check24.birthday.getMaxAge(element);

                    if (null !== minAge && yearsDifference < minAge) {
                        if (window.Check24.birthday.getIsDefaultErrorText(element) === true) {
                            window.Check24.birthday.error(window.Check24.birthday.errorTextEmpty, element);
                        } else {
                            window.Check24.birthday.error(window.Check24.birthday.getErrorTextMinAge(element), element);
                        }
                        event.preventDefault();
                        return false;
                    }
                    if (null !== maxAge && yearsDifference > maxAge) {
                        if (window.Check24.birthday.getIsDefaultErrorText(element) === true) {
                            window.Check24.birthday.error(window.Check24.birthday.errorTextEmpty, element);
                        } else {
                            window.Check24.birthday.error(window.Check24.birthday.getErrorTextMaxAge(element), element);
                        }
                        event.preventDefault();
                        return false;
                    }

                    errorElement.style.display = 'none';

                    const eleValue = window.Check24.birthday.getDate(window.Check24.birthday.getIsPlaneInput(element), element.value);
                    if (eleValue === undefined) {
                        element.value = '';
                        return false;
                    }

                    const submitElement = element.closest('.c24-yellow-box ').querySelector('.c24-yellow-box-submit-input');
                    submitElement.value = window.Check24.birthday.getDate(window.Check24.birthday.getIsPlaneInput(element), element.value);

                    return true;
                });
            });
        },
        getDate: function(planeInput, bd) {
            if (bd === '' || bd === undefined) {
                return null;
            }
            let parts = bd.split(/\./, 3);
            planeInput = planeInput || false;

            if (planeInput === true) {
                return parts[2] + parts[1] + parts[0];
            }

            return parts[2] + '-' + parts[1] + '-' + parts[0];
        },
        error: function(text, ele) {
            const errorElement = ele.closest('.c24-birthday-box').querySelector('.c24-birthdate-form-error');

            ele.closest('.c24-yellow-box-input-wrapper').classList.add('c24-error');
            if (ele.closest('.c24-yellow-box-input-wrapper')) {
                ele.closest('.c24-yellow-box-input-wrapper').classList.add('error');
                ele.closest('.c24-yellow-box').classList.add('error');
            }
            errorElement.style.display = 'block';
            errorElement.innerHTML = text;
        },
        isValidDate: function(element) {
            if (!element) {
                return false;
            }
            const date = element.value;
            let parts = date.split(/\./, 3);
            let checkDate = new Date(window.Check24.birthday.getDate(window.Check24.birthday.getIsPlaneInput(element), date));

            return parts.length === 3
            && checkDate.getUTCFullYear() === parseInt(parts[2])
            && checkDate.getUTCMonth() + 1 === parseInt(parts[1])
            && checkDate.getUTCDate() === parseInt(parts[0]);
        },
    };
});

window.c24DomReady(function() {
    window.c24LpFrameJsReady.then(function() {
        window.c24LpCssLoaded.then(function() {
            window.Check24.birthday.init();
        });
    });
});
